module.exports = __webpack_public_path__ + "img/TV_clean_box14.c5457906.jpg";